module.exports = __webpack_public_path__ + "img/excel-3x.15d46622.png";